import { applicationOfflineStore } from './application-offline.store';
export const ApplicationOfflineInterceptor = (error) => {
    if (window.navigator && window.navigator.onLine === false) {
        applicationOfflineStore.setOffline(true);
    }
    return Promise.reject(error);
};
